<template>
	<div class="absolute">
		<!-- Swap Dialog -->
			<modal
			:hide-footer="true"
			@close="close"
            size="large">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Device Monitor') }}</h5>
            </template>
            <template slot="body">
                <program-monitor @done="close"></program-monitor>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
	</div>
</template>

<script>
import ProgramMonitor from './ProgramMonitor.vue';
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalProgramMonitor',
	components: {
		Modal,
		ProgramMonitor,
	},
	props: {},
	mounted() {
	},
	data: () => ({
	}),
	methods: {
		close() {
			// this.stopVideoOnly();
			this.$emit('close');
		},
		// setStream(stream) {
		// 	if (stream) {
		// 		this.stream = stream;
		// 	}
		// },
		// stopVideoOnly() {
		// 	if (this.stream) {
		// 		this.stream.getTracks().forEach((track) => {
		// 			track.stop();
		// 		});
		// 	}
		// },
	},
	computed: {
	},
};
</script>

<style lang="scss" scoped>
.material-icons-group {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    padding: 0px;
    margin: 0px;
    font-size: 80px;
	color: #FFA800;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
.material-icons-swap {
    font-family: 'Material Icons';
    position: rela;
    padding: 0px;
    margin: 0px;
    font-size: 60px;
	color: #FFA800;
    line-height: 1;
}
.wrapper-offline{
		text-align: center!important;
	}
</style>
